import {defineStore} from 'pinia';
import { ref } from 'vue';
import api from '../api/client.js';
import { useConversationStore } from './conversation.js';


export const useWidgetStore = defineStore('widget', () => {

    /**
     * Other stores
     */
    const conversationStore = useConversationStore();
    const token = ref(null);
    const disclaimerOpened = ref(false);
    const displayClassCache = ref({});
    
    const getConversationId = () => {
        return conversationStore.conversationId;
    }


    /**
     * Colors
     */

    const primaryColor = ref('#F35627');
    const secondaryColor = ref('#FFFEFD');
    const backgroundColor = ref('#01182F');

    const setPrimaryColor = (color) => {
        primaryColor.value = color;
    }

    const setSecondaryColor = (color) => {
        secondaryColor.value = color;
    }

    const setBackgroundColor = (color) => {
        backgroundColor.value = color;
    }


    /**
     * essentials
     */

    const isLoading = ref(true);
    const botId = ref(null);
    const bot = ref(null);

    const setBot = (bot) => {
        bot.value = bot;
    }

    const setIsLoading = (loading) => {
        isLoading.value = loading;
    }

    const loadBot = async (botIdParam, tokenParam) => {
        console.log('loadBot', botIdParam, tokenParam);
        isLoading.value = true;
        token.value = tokenParam;
        botId.value = botIdParam;

       return api.fetchBot(botId.value).then(({ data }) => {
            bot.value = data.data;
            primaryColor.value = data.data.colors.primary;
            secondaryColor.value = data.data.colors.secondary;
            backgroundColor.value = data.data.colors.background;

            const conversationId = getConversationId();
        
            if (conversationId !== undefined && conversationId !== null) {
                conversationStore.loadConversation();
            }
            setTimeout(() => {
                isLoading.value = false;
            }, 500);

            return data.data;
        });
    }
    

    /**
     * Other UI Things
     */

        
    const isChatOpen = ref(localStorage.getItem('isChatOpen') === 'true' || false);


    const toggleChat = () => {
        isChatOpen.value = !isChatOpen.value;
        localStorage.setItem('isChatOpen', isChatOpen.value);
        closeTeaser();
        handleCommonOverlayIssues();
    };
    const closeChat = () => {
        isChatOpen.value = false;
        localStorage.setItem('isChatOpen', false);
        handleCommonOverlayIssues();
    };

    const openChat = () => {
        isChatOpen.value = true;
        localStorage.setItem('isChatOpen', true);
        closeTeaser();
        handleCommonOverlayIssues();
    };


    const teaserMessageOpen = ref(false);
    const setTeaserMessageOpen = (open) => {
        teaserMessageOpen.value = open;
    }

    const teaserMessage = ref(null);
    const setTeaserMessage = (message) => {
        teaserMessage.value = message;
    }

    const closeTeaser = () => {
        shouldShowTeaserMessage.value = false;
        teaserMessageOpen.value = false;
        localStorage.setItem('teaserClosed', true);
    }

    const shouldShowTeaserMessage = ref(!localStorage.getItem('teaserClosed'));
    const setShouldShowTeaserMessage = (show) => {
        shouldShowTeaserMessage.value = show;
    }

    const toggleDisclaimer = () => {
        disclaimerOpened.value = !disclaimerOpened.value;
    }



    const handleCommonOverlayIssues = () => {

        // just trigger, when mobile
        if (window.innerWidth > 768) {
        return;
        }
    
        const elementIdsToBeHiddenWhenOpen = ['header', 'footer', 'cookie-banner', 'usercentrics-root'];
    
        if (isChatOpen.value) {
        elementIdsToBeHiddenWhenOpen.forEach((id) => {
            const element = document.getElementById(id);
            if (element) {
                displayClassCache.value[id] = element.style.display;
                element.style.display = 'none';
            }
        });
        } else {
        elementIdsToBeHiddenWhenOpen.forEach((id) => {
            const element = document.getElementById(id);
            if (element) {
            element.style.display = displayClassCache.value[id] || 'block';
            }
        });
        }
    };

    
    return {

        //colors
        primaryColor,
        secondaryColor,
        backgroundColor,
        setPrimaryColor,
        setSecondaryColor,
        setBackgroundColor,

        // essentials
        isLoading,
        botId,
        bot,
        loadBot,
        setBot,
        setIsLoading,

        // other ui things
        isChatOpen,
        disclaimerOpened,
        toggleChat,
        closeChat,
        openChat,
        handleCommonOverlayIssues,
        toggleDisclaimer,

        // teaser message
        teaserMessageOpen,
        setTeaserMessageOpen,
        teaserMessage,
        setTeaserMessage,
        closeTeaser,
        shouldShowTeaserMessage,
        setShouldShowTeaserMessage,
    }
});